import { Box, Divider, Typography } from '@mui/material';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';

type FundraiserTitleAndValueRowProps = {
  title: string;
  currencyValue: number;
};

export const FundraiserTitleAndValueRow = (props: FundraiserTitleAndValueRowProps) => {
  const { title, currencyValue } = props;
  return (
    <>
      <Box sx={{ py: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography color='textSecondary' variant='body2' fontWeight={(thm) => thm.typography.fontWeightMedium} textTransform='uppercase'>
          {title}
        </Typography>
        <Box>
          <Typography variant='h5' fontWeight={(thm) => thm.typography.fontWeightBold} display='inline'>
            <AmountWithCurrency amount={currencyValue} decimals={0} showCurrencyInSecondaryStyle currencyVariant='body2' />
          </Typography>
        </Box>
      </Box>
      <Divider />
    </>
  );
};
